<template>
  <div :id="id" class="card-input">

  </div>
</template>

<script>
export default {
  data() {
    return {
      uuid: Math.UUID()
    }
  },
  mounted() {
    var style = {
      base: {
        color: '#3ebe6d',
        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
        fontSmoothing: 'antialiased',
        fontSize: '16px',
        
        '::placeholder': {
          color: '#7f8690',
        },
      },
      invalid: {
        color: '#fa755a',
        iconColor: '#fa755a',
      },
    };

    var cardElement = this.$env.stripe.elements()
      .create('card', { style: style });
    cardElement.mount('#' + this.id);
    cardElement.on('change', event => {
      this.$emit('input', cardElement);
    });
    cardElement.on('blur', event => {
      this.$emit('input', cardElement);
    });
    this.interval = setInterval(() => {
      this.$emit('input', cardElement);
    }, 1000);
    this.card = cardElement;
  },
  computed: {
    
    id() {
      return 'card_input_' + this.uuid
    }
  },
  destroyed() {
    clearInterval(this.interval);
  }
}
</script>

<style lang="scss" scoped>

.card-input {
  height: 40px;
  border: 1px solid #e0e0e0;
  border-radius: 3px;
  border-style: solid;
  background-color: #fff;
  color: $mainGreen;
  box-shadow: 0 0 0 transparent;
  transition: box-shadow 0.3s ease, border-color 0.3s ease;
  padding: 9px 12px;

  &:focus {
    border-color: $mainGreen;
    box-shadow: 0 2px 10px rgba($color: $mainGreen, $alpha: 0.4);
  }
}

</style>